import { styled } from '@material-ui/core/styles';

import PortabilityImg from '../../../img/who-we-are-portability.png';

export const Container = styled('div')(({ theme }) => ({
  height: '80%',
  width: '100%',
  background: theme.palette.background.secondary,
  [theme.breakpoints.down('sm')]: {
    minHeight: '100%',
    padding: '2rem 0 1em',
  },
}));

export const Content = styled('div')(({ theme }) => ({
  height: '100%',
  maxWidth: 1280,
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  [theme.breakpoints.down('1367')]: {
    maxWidth: 1200,
  },
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'space-evenly',
    flexDirection: 'column-reverse',
  },
}));

export const Info = styled('div')(({ theme }) => ({
  width: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  '& > div': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  '& header': {
    width: '80%',
  },
  '& p ': {
    width: '80%',
    marginBottom: 0,
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    textAlign: 'center',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    '& header': {
      width: '100%',
    },
    '& p ': {
      width: '100%',
    },
  },
  [theme.breakpoints.down('xs')]: {
    width: '90%',
  },
}));

export const Divider = styled('hr')(({ theme }) => ({
  width: '10%',
  border: `1px solid ${theme.palette.primary.main}`,
  margin: '10px 70%',
  [theme.breakpoints.down('sm')]: {
    margin: '20px auto',
  },
}));

export const Image = styled('div')(({ theme }) => ({
  height: '65vh',
  width: '60%',
  background: `url(" ${PortabilityImg}") no-repeat`,
  backgroundSize: 'contain',
  [theme.breakpoints.down('sm')]: {
    height: '50%',
    width: '100%',
    backgroundPositionX: 'center',
  },
}));
